import styles from "./index.less";
import classNames from "classnames";
import copy from "../../../assets/copy.svg";
import contextDel from "../../../assets/contextDel.svg";
import topTrans from "../../../assets/topTrans.svg";
import bottomTrans from "../../../assets/bottomTrans.svg";
import toTop from "../../../assets/toTop.svg";
import toBottom from "../../../assets/toBottom.svg";
import { useCanvasByContext } from "../../../store/hook";

export default function ContextMenu({ style }) {
  const canvas = useCanvasByContext();

  const copyCmp = (e) => {
    e.stopPropagation();
    canvas.addAssemblyCms();
  };

  const delCmp = (e) => {
    e.stopPropagation();
    canvas.deleteCmp();
  };

  const addCmpZIndex = (e) => {
    e.stopPropagation();
    canvas.addCmpZIndex();
  };

  const subCmpZIndex = (e) => {
    e.stopPropagation();
    canvas.subCmpZIndex();
  };

  const topCmpZIndex = (e) => {
    e.stopPropagation();
    canvas.topCmpZIndex();
  };

  const bottomCmpZIndex = (e) => {
    e.stopPropagation();
    canvas.bottomCmpZIndex();
  };

  const hasAssembly = canvas.hasAssembly();

  return (
    <ul className={classNames(styles.main)} style={style}>
      <li className={styles.item} onClick={(e) => copyCmp(e)}>
        <img src={copy} alt="copy" />
        <span>复制</span>
      </li>
      <li className={styles.item} onClick={(e) => delCmp(e)}>
        <img src={contextDel} alt="contextDel" />
        <span>删除</span>
      </li>
      {!hasAssembly && (
        <>
          <li className={styles.item} onClick={(e) => addCmpZIndex(e)}>
            <img src={topTrans} alt="topTrans" />
            <span>上移</span>
          </li>
          <li className={styles.item} onClick={(e) => subCmpZIndex(e)}>
            <img src={bottomTrans} alt="bottomTrans" />
            <span>下移</span>
          </li>
          <li className={styles.item} onClick={(e) => topCmpZIndex(e)}>
            <img src={toTop} alt="toTop" />
            <span>置顶</span>
          </li>
          <li className={styles.item} onClick={(e) => bottomCmpZIndex(e)}>
            <img src={toBottom} alt="toBottom" />
            <span>置底</span>
          </li>
        </>
      )}
    </ul>
  );
}
